import React from 'react'
import { Modal, ModalProps, Platform } from 'react-native'

export const AppModal = (props: ModalProps) => (
  <Modal statusBarTranslucent={Platform.OS === 'android'} {...props} />
)
